module.exports = __webpack_public_path__ + "static/media/cardsurya.d1980600.jpg";